export const LOCALIZED_TITLE_MAX_LENGTH = 100;
